module.exports = __webpack_public_path__ + "img/22.670f357a.jpg";